import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { Globals } from "../../../../globals";
import { ConfigurationServices } from "../../services";

/**
 * Generated class.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-configuration-close-cash-view-print-resumen',
  templateUrl: 'configuration-close-cash-view-print-resumen.html',
})
export class ConfigurationCloseCashViewPrintResumenPage {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public configurationServices: ConfigurationServices) {
  }
}



// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-close-cash/configuration-close-cash-view-print-resumen/configuration-close-cash-view-print-resumen.ts